import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../Checkbox'

import * as styles from './SelectDropdownEntityListItemContentContainer.module.css'

function SelectDropdownEntityListItemContentContainer({
  children,
  className = styles.SelectDropdownEntityListItemContentContainer,
  disabled,
  isHovered,
  isSelected,
  multi,
  style,
}) {
  return (
    <div className={className} style={style}>
      {multi ? (
        <Checkbox
          checked={isSelected}
          className={styles.checkbox}
          disabled={disabled}
          hovered={isHovered}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.table}
        />
      ) : null}
      {children}
    </div>
  )
}

export default SelectDropdownEntityListItemContentContainer
